export const baseURL: any = process.env.REACT_APP_API_ENDPOINT
export const chatWsBaseURL: any = process.env.REACT_APP_CHAT_API_ENDPOINT
export const mediaUrl: any = process.env.REACT_APP_MEDIA_API_ENDPOINT
export const privacyPolicy = 'https://sales-media.checkout-apps.com/privacy.html'
export const termsOfUse = 'https://sales-media.checkout-apps.com/terms.html'
const urlEnv = 'temp-v1'
const urlEnv2 = 'temp-v2'
const urlEnv3 = 'temp-v1'

export default {
  tasks: (rid: string, groups: string) => `${baseURL}/${urlEnv}_tasks-ms/?rid=${rid}&groups=${groups}`,
  getReport: `${baseURL}/${urlEnv}_data-ms/data/reports?`,
  getReportDynamicParams: `${baseURL}/${urlEnv}_data-ms/data/dynamic_parameters`,
  deleteTask: `${baseURL}/${urlEnv}_tasks-ms/`,
  getInsights: `${baseURL}/${urlEnv}_tasks-ms/insights/`, // POST request
  getSubtasks: (tids: string[], groups: string[]) =>
    `${baseURL}/${urlEnv}_tasks-ms/?tids=${tids.join(',')}&groups=${groups.join(',')}`,
  createTask: `${baseURL}/${urlEnv}_tasks-ms/`,
  initialTranslations: `${mediaUrl}/translations.json`,
  config: `${baseURL}/${urlEnv3}_users-ms/config`,
  amazonUploadingLink: `${baseURL}/${urlEnv}_media/s3/signed_url`,
  updateSubtask: `${baseURL}/${urlEnv}_tasks-ms/sub_tasks`,
  updateUser: `${baseURL}/${urlEnv3}_users-ms/users/`,
  posts: `${baseURL}/${urlEnv}_posts-ms/posts`,
  post: `${baseURL}/${urlEnv}_posts-ms/posts/post/`,
  likes: (postId: string) => `${baseURL}/${urlEnv}_posts-ms/likes?post_id=${postId}`,
  sentryDSN: 'https://4081af403cba4b2abdde0f7baae7f936@sentry.io/1882800',
  privacy: 'https://sales-media.checkout-apps.com/privacy.html',
  terms: 'https://sales-media.checkout-apps.com/terms.html',
  appStore: 'https://apps.apple.com/us/app/store-e/id1497463008?ls=1',
  googlePlay: 'https://play.google.com/store/apps/details?id=com.storee.checkout.app',
  comments: `${baseURL}/${urlEnv}_comments-ms/comments?`,
  commentsCounter: `${baseURL}/${urlEnv}_comments-ms/comments/count?`,
  resetPassword: `${baseURL}/${urlEnv3}_users-ms/reset_password?`,
  getUserWritePermittedContext: `/${urlEnv}_posts-ms/permission/write`,
  getUserTaskPermissions: `/${urlEnv2}_tasks-ms/permission/write?`,
  signedUrl: `${baseURL}/${urlEnv}_media/s3/signed_url`,
  pingUsers: `${baseURL}/${urlEnv}_posts-ms/ping`,
  pingTask: `${baseURL}/${urlEnv2}_tasks-ms/ping`,
  cloudViewer: (fileUrl: string) => `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(fileUrl)}`,
  getRanking: `${baseURL}/${urlEnv}_data-ms/data/ranking`,
  searchPosts: `${baseURL}/${urlEnv}_posts-ms/search_posts`,
  pop: `${baseURL}/${urlEnv}_pops-ms/pops`,
  launchExternalApp: `${baseURL}/${urlEnv}_general-ms/external-apps/launch`,
  popById: `${baseURL}/${urlEnv}_pops-ms/pops/pop`,
  popData: `${baseURL}/${urlEnv}_pops-ms/pops/pop/data`,
  submitPop: `${baseURL}/${urlEnv}_pops-ms/pops/ack`,
  submitRePop: `${baseURL}/${urlEnv}_pops-ms/pops/repop`,
  getRetailUsers: (rid: string) => `${baseURL}/${urlEnv3}_users-ms/retail_users?rid=${rid}`,
  usersWithAttrs: (rid: string) => `${baseURL}/${urlEnv3}_users-ms/users_with_attrs?rid=${rid}`,
  logout: `${baseURL}/${urlEnv}_users-ms/logout`,
  users: `${baseURL}/${urlEnv}_users-ms/users?`,
  getUser: (auth_context: number, uid?: string) =>
    `${baseURL}/${urlEnv}_users-ms/users?uid=${uid}&auth_context=${auth_context}`,
  updateGroup: `${baseURL}/${urlEnv}_users-ms/group?`,
  tag: `${baseURL}/${urlEnv}_users-ms/tag`,
  readReportsPermissions: (group: string) =>
    `${baseURL}/${urlEnv}_data-ms/data/read_reports_permission_users?group=${group}`,
  pinManager: `${baseURL}/${urlEnv}_posts-ms/update_pin_post`,
  views: (postId: string) => `${baseURL}/${urlEnv}_posts-ms/views?post_id=${postId}`,
  updateViews: `${baseURL}/${urlEnv}_comments-ms/comments/views`,
  socketGPT: (token: any) => `${chatWsBaseURL}v1_chat_gpt/?Auth=${token}`,
  getActivities: (oid: string) => `${baseURL}/${urlEnv}_comments-ms/comments/activities?oid=${oid}`,
  updateLikes: `${baseURL}/${urlEnv}_comments-ms/comments/update_likes`,
  updateCommentViews: `${baseURL}/${urlEnv}_comments-ms/comments/update_views`,
  getSiteMetaData: (url: string) => `${baseURL}/${urlEnv}_media/preview?url=${encodeURIComponent(url)}`,
  tasksV2: `${baseURL}/${urlEnv2}_tasks-ms/`,
  getTaskV2: `${baseURL}/${urlEnv2}_tasks-ms/task`,
  getAllResults: (contextId: string) => `${baseURL}/${urlEnv2}_tasks-ms/results/all?context_id=${contextId}`,
  updateResults: `${baseURL}/${urlEnv2}_tasks-ms/results`,
  getSubtasksResultsOverview: `${baseURL}/${urlEnv2}_tasks-ms/results/context`,
  getProvider: (email: string) => `${baseURL}/${urlEnv}_users-ms/provider?email=${email}`,
  getTaskInsights: `${baseURL}/${urlEnv2}_tasks-ms/insights/task`,
  getInsightsV2: `${baseURL}/${urlEnv2}_tasks-ms/insights/`,
  getTaskData: `${baseURL}/${urlEnv2}_tasks-ms/task-data`,
  deleteCommentsOfImage: `${baseURL}/${urlEnv}_comments-ms/comments/parent_cid`,
  getResultsOfRecurringTaskInsights: `${baseURL}/${urlEnv2}_tasks-ms/insights/results`,
  serviceCalls: `${baseURL}/${urlEnv}_service_calls-ms`,
  serviceCall: `${baseURL}/${urlEnv}_service_calls-ms/service_call`,
  serviceCallsDashboard: `${baseURL}/${urlEnv}_service_calls-ms/dashboard`,
  resetResults: `${baseURL}/${urlEnv2}_tasks-ms/results`,
  resultStatus: `${baseURL}/${urlEnv2}_tasks-ms/results/status`,
  createServiceCallChatToken: `${baseURL}/${urlEnv}_service_calls-ms/create_chat_token`,
  OTP: `${baseURL}/${urlEnv3}_users-ms/otp`,
  loginOTP: `${baseURL}/${urlEnv3}_users-ms/otp-login`,
  // Admin-tool-initiated view-as login — public, single-use, code-in-URL-hash only. See pages/AdminLoginAs.tsx.
  viewAsRedeem: (code: string) =>
    `${baseURL}/${urlEnv3}_users-ms/admin/view-as-tokens/redeem?code=${encodeURIComponent(code)}`,
  analytics: `${baseURL}/${urlEnv3}_users-ms/users/analytics`,
  jobs: `${baseURL}/${urlEnv}_jobs-ms`,
  myJobs: `${baseURL}/${urlEnv}_jobs-ms/my`,
  updateJobStatus: `${baseURL}/${urlEnv}_jobs-ms/status`,
  jobActionReference: `${baseURL}/${urlEnv}_jobs-ms/action`,
  prompt: `${baseURL}/${urlEnv}_gpt-ms/gpt/prompt`,
  llmInteraction: `${baseURL}/${urlEnv}_gpt-ms/gpt/llm_interaction`,
  taskSummary: `${baseURL}/${urlEnv2}_tasks-ms/summary/task`,

  retailCampaigns: `${baseURL}/${urlEnv}_data-ms/data/campaigns/console`, // get retail campaings by type
  campaignsByGroup: `${baseURL}/${urlEnv}_data-ms/data/campaigns`, // get campaigns by group
  updateCampaignStatus: `${baseURL}/${urlEnv}_data-ms/data/campaign/status`,
  campaign: `${baseURL}/${urlEnv}_data-ms/data/campaign`, // get campaign by campaign id
  campaignData: `${baseURL}/${urlEnv}_data-ms/data/campaign_data`, // get campaign data
  presetPrompts: `${baseURL}/${urlEnv}_gpt-ms/gpt/preset_prompts`,

  // Product Performance — best-seller data per store or area
  productPerformance: `${baseURL}/${urlEnv}_data-ms/data/campaign_data_on_demand`,
  productDetails: `${baseURL}/${urlEnv}_data-ms/data/campaigns/product_details`,

  // Library (Drive service) — folders, files, links, presigned S3 URLs, roots
  driveRoots: `${baseURL}/${urlEnv}_drive-ms/roots`,
  driveFolders: `${baseURL}/${urlEnv}_drive-ms/folders`,
  driveFolderContents: (folderId: string, limit = 50, cursor = '') =>
    `${baseURL}/${urlEnv}_drive-ms/folders/${folderId}?limit=${limit}${cursor ? `&cursor=${cursor}` : ''}`,
  driveFolder: (folderId: string) => `${baseURL}/${urlEnv}_drive-ms/folders/${folderId}`,
  driveFiles: `${baseURL}/${urlEnv}_drive-ms/files`,
  driveFile: (fileId: string) => `${baseURL}/${urlEnv}_drive-ms/files/${fileId}`,
  driveUploadUrl: `${baseURL}/${urlEnv}_drive-ms/files/upload-url`,
  driveDownloadUrl: (fileId: string) => `${baseURL}/${urlEnv}_drive-ms/files/${fileId}/download-url`,
  driveAccess: `${baseURL}/${urlEnv}_drive-ms/access`,
  driveRecordView: (fileId: string) => `${baseURL}/${urlEnv}_drive-ms/files/${fileId}/view`,
  driveViewStats: (fileId: string) => `${baseURL}/${urlEnv}_drive-ms/files/${fileId}/views`,
  driveViewHistory: (fileId: string, limit = 50, cursor = '') =>
    `${baseURL}/${urlEnv}_drive-ms/files/${fileId}/view-history?limit=${limit}${cursor ? `&cursor=${cursor}` : ''}`,
  driveNodes: (types = '') => `${baseURL}/${urlEnv}_drive-ms/nodes${types ? `?types=${types}` : ''}`,

  // Notifications hub — inbox, unread list/count, mark-seen (WA-931)
  notificationsInbox: (limit = 20, cursor = '') =>
    `${baseURL}/${urlEnv}_notifications-ms/?limit=${limit}${cursor ? `&cursor=${cursor}` : ''}`,
  notificationsUnread: (limit = 20, cursor = '') =>
    `${baseURL}/${urlEnv}_notifications-ms/unread?limit=${limit}${cursor ? `&cursor=${cursor}` : ''}`,
  notificationsUnreadCount: `${baseURL}/${urlEnv}_notifications-ms/unread_count`,
  notificationsSeen: `${baseURL}/${urlEnv}_notifications-ms/seen`,
}
